const NAME_VALIDATOR = /^([A-zÀ-ÿ$&+,:;=?@#|/\\'ˆ˜<>.*()%!-"'0-9-])+( [A-zÀ-ÿ$&+,:;=?@#|/\\'ˆ˜<>.*()%!-"'0-9-][A-zÀ-ÿ$&+,:;=?@#|/\\ˆ˜'<>.*()%!-"'0-9-]*)+$/
const NAME_SPECIAL_CHARACTERES_VALIDATOR = /^[-A-ZÀ-Ÿa-zà-ÿ']+( [-A-ZÀ-Ÿa-zà-ÿ']+)+$/
const USERNAME_VALIDATOR = /^[a-zA-Z0-9_.-]+$/
const SPECIAL_CHARACTERES_VALIDATOR = /^[A-ZÀ-Ÿa-zà-ÿ'][A-ZÀ-Ÿa-zà-ÿ']+( [A-ZÀ-Ÿa-zà-ÿ'][A-ZÀ-Ÿa-zà-ÿ']*)+$/
const PASSWORD_VALIDATOR = /^.{6,}$/
const EMAIL_VALIDATOR = '^([a-zA-Z0-9_\\-\\.+]+)@([a-zA-Z0-9_\\-\\.+]+)\\.([a-zA-Z]{2,20})$'
const HIDE_EMAIL = /^(.)(.*)(@.*)$/
const NUMBER_VALIDATOR = /^[0-9]+$/

export {
  NAME_VALIDATOR,
  USERNAME_VALIDATOR,
  SPECIAL_CHARACTERES_VALIDATOR,
  PASSWORD_VALIDATOR,
  EMAIL_VALIDATOR,
  HIDE_EMAIL,
  NUMBER_VALIDATOR,
  NAME_SPECIAL_CHARACTERES_VALIDATOR,
}
